import client from '../helpers/authenticated-axios';

export const cacheUsageService = {
    async getCacheUsageList(page, itemsPerPage) {
        return await client().get(`/cache_memories/page/${page}/${itemsPerPage}`);
    },
    async getCacheUsageDetail(flowExecutionId) {
        return await client().get(`/cache_memories/${flowExecutionId}`);
    }
}